import type { JSX } from 'react';

import { ModuleSeparator } from 'src/app/pages/starterDashboardV2/shared/components';
import { useMarkModuleAsLoaded } from 'src/app/pages/starterDashboardV2/shared/contexts';

import { PromotionHistory } from './components/PromotionHistory';
import { RecentPromotionsList } from './components/RecentPromotionsList';
import { TopSignatureSources } from './components/TopSignatureSources';
import { usePetitionInsights } from './hooks/usePetitionInsights';

export function PetitionInsights(): JSX.Element | null {
	const { data } = usePetitionInsights();

	useMarkModuleAsLoaded('PetitionInsights', data.shouldShowPetitionInsights);

	if (!data.shouldShowPetitionInsights) return null;
	return (
		<section aria-labelledby="petition-insights-title" role="group" data-qa="promotion-insights">
			{data.shouldShowPromotionStats && (
				<>
					<div className="border-stroke-weaker bg-background-base flex flex-col gap-6 py-6 md:py-12">
						<PromotionHistory />
						<RecentPromotionsList />
					</div>
					<ModuleSeparator />
				</>
			)}
			{data.shouldShowSignatureSources && (
				<div className="bg-background-base px-4 py-8 md:px-12 md:py-12">
					<TopSignatureSources />
				</div>
			)}
		</section>
	);
}
